export default __webpack_public_path__ + "static/media/about1.dd13ed4a.jpg";